<template>
  <div class="container main-content">
    <h1>Alle Voralgen</h1>
    <router-link class="btn btn-primary mb-4" role="button" :to="{name: 'createProposal'}">
      Neue Vorlage
    </router-link>
    <b-table striped bordered hover :items="proposals" :fields="fields" :busy="loading">
      <div slot="table-busy" class="text-center text-danger my-2">
        <b-spinner class="align-middle"></b-spinner>
        <strong>Loading...</strong>
      </div>
      <template slot="edit" slot-scope="row">
        <router-link class="btn btn-secondary btn-block" role="button" :to="{name: 'updateProposal', params: {id: row.item.id}}">
          <icon icon="edit" />
        </router-link>
      </template>
      <template slot="delete" slot-scope="row">
        <b-button variant="secondary" block @click="deleteProposal(row.item.id, row.index)">
          <icon icon="trash-alt" />
        </b-button>
      </template>
    </b-table>
  </div>
</template>

<script>
import client from 'api-client';

export default {
  name: 'List',

  data() {
    return {
      proposals: [],
      fields: [
        {
          key: 'id', label: 'Id', sortable: true,
        },
        {
          key: 'name', label: 'Name', sortable: true,
        },
        {
          key: 'Status', label: 'Status', sortable: true,
        },
        {
          key: 'effectiveDate', label: 'Abstimmung am', sortable: true, sortDirection: 'asc',
        },
        {
          key: 'edit', label: 'Bearbeiten',
        },
        {
          key: 'delete', label: 'Löschen',
        },
      ],
      loading: true,
    };
  },
  created() {
    client
      .adminFetchProposalList()
      .then(proposals => this.setProposals(proposals))
      .catch((e) => {
        console.error(e);
        this.error = true;
      });
  },
  methods: {
    setProposals(proposals) {
      this.proposals = proposals;
      this.loading = false;
    },
    deleteProposal(id, index) {
      this.proposals.splice(index, 1);
      this.$bvToast.toast(`Vorlage gelöscht: ${id}`, {
        title: 'Bestätigung',
        autoHideDelay: 5000,
      });
    },
  },
};
</script>
